import React, { useState } from "react";
import { Phone, Clock, MapPin } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Contact = () => {
  const [activeTab, setActiveTab] = useState("contact");
  const [fullName, setFullName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Full Name:", fullName);
    const whatsappNumber = "+60186668183";
    const message = `Hello, my name is ${fullName}! I am from the GasesDex website and I would like to make an inquiry.`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="flex justify-center px-8 py-2 mt-10">
      <div className="w-full">
        <h2 className="text-4xl md:text-5xl font-medium text-gray-800 text-center">
          Contact Us
        </h2>

        {/* Tabs */}
        <div className="grid grid-cols-2 gap-5 mt-6 md:mt-10 md:px-8 mb-3 text-base">
          <div
            className={`border rounded-xl  shadow-lg p-4 px-8 text-center flex items-center justify-center hover:cursor-pointer transition-all duration-200 ${
              activeTab === "contact"
                ? "outline outline-1 outline-gray-400"
                : "hover:outline hover:outline-1 hover:outline-gray-500"
            }`}
            onClick={() => setActiveTab("contact")}
          >
            Contact Information
          </div>

          <div
            className={`border rounded-xl shadow-lg p-4 px-8 text-center flex items-center justify-center hover:cursor-pointer transition-all duration-200 ${
              activeTab === "company"
                ? "outline outline-1 outline-gray-400"
                : "hover:outline hover:outline-1 hover:outline-gray-500"
            }`}
            onClick={() => setActiveTab("company")}
          >
            Company Information
          </div>
        </div>

        <div className="md:px-8">
          {/* Inquiry Form */}
          {activeTab === "contact" && (
            <div className="p-5 border border-gray-400 mt-5 rounded-3xl">
              <p className="text-3xl font-semibold mb-2">Submit an Inquiry</p>
              <p className="text-gray-600 mb-6">
                Complete the form below, and one of our representatives will
                contact you as soon as possible.
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Name Input */}
                <div>
                  <label className="block text-gray-700 font-medium">
                    Full Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your name"
                    onChange={(e) => setFullName(e.target.value)}
                    className="w-full mt-2 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    required
                  />
                </div>

                {/* Contact Input */}
                <div>
                  <label className="block text-gray-700 font-medium">
                    Contact
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your email or phone"
                    className="w-full mt-2 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    required
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full md:w-1/3 bg-green-600 text-white text-xl py-3 flex items-center justify-center rounded-xl font-medium hover:bg-green-700 hover:shadow-lg transition-all duration-300 transform hover:scale-105 gap-2"
                >
                  <FontAwesomeIcon icon={faWhatsapp} className="w-8 h-8" />
                  <span className="text-center tracking-wide">WhatsApp Us</span>
                </button>
              </form>
            </div>
          )}

          {/* Company Information */}
          {activeTab === "company" && (
            <div className="p-6 border border-gray-300 mt-6 rounded-2xl shadow-lg bg-white">
              <p className="text-3xl font-semibold text-gray-800 mb-4">
                Company Information
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our company specializes in providing high-quality products and
                services. We are dedicated to customer satisfaction and
                excellence.
              </p>

              <div className="mt-6 space-y-5">
                {/* Contact Numbers */}
                <div>
                  <h2 className="text-xl font-medium text-gray-700 pb-2 border-b border-gray-300">
                    Contact Numbers
                  </h2>
                  <ul className="mt-2 space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <Phone className="w-5 h-5 mr-3 text-blue-600" />
                      <span className="font-medium">
                        +6018 - 666 8183 (Jeff)
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Operating Hours */}
                <div>
                  <h2 className="text-xl font-medium text-gray-700 pb-2 border-b border-gray-300">
                    Operating Hours
                  </h2>
                  <ul className="mt-2 space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <Clock className="w-5 h-5 mr-3 text-green-600" />
                      <span className="font-medium">
                        Mon - Fri: 9:00 AM - 6:00 PM
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Office Location */}
                <div>
                  <h2 className="text-xl font-medium text-gray-700 pb-2 border-b border-gray-300">
                    Office Location
                  </h2>
                  <ul className="mt-2 space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <MapPin className="w-5 h-5 mr-3 text-red-600" />
                      <p className="text-gray-800 leading-relaxed">
                        No. 9 Jalan PUJ 3/11, Puncak Jalil, <br />
                        Bandar Baru Permai, 43300 Seri Kembangan, <br />
                        Selangor, Malaysia
                      </p>
                    </li>
                  </ul>

                  <div className="mt-4 overflow-hidden rounded-lg shadow-md">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3984.270718052739!2d101.6757944!3d3.0217885!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cdb555b942535f%3A0xc0432eb7bfc9a9a6!2sGases%20Dex%20Sdn%20Bhd%20(Gas%20Equipment%20Supplier)!5e0!3m2!1sen!2smy!4v1741970925896!5m2!1sen!2smy"
                      width="100%"
                      height="350"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      className="w-full h-[350px] rounded-lg"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
